import { Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import {
  KnowledgeBaseViewPage,
  KnowledgeBaseDocumentView,
} from 'pages/settings/pages/knowledgeBase/pages'
import { KnowledgeBaseAccessLayout } from 'pages/settings/pages/knowledgeBase/layout/KnowledgeBaseAccessLayout'
import { KnowledgeBasePageLayout } from 'pages/settings/pages/knowledgeBase/layout/KnowledgeBasePageLayout'
import { KnowledgeBaseRoutes } from './type'

export const KnowledgeBaseRouter = observer(() => {
  return (
    <RoutesWithNotFound>
      <Route element={<KnowledgeBaseAccessLayout />}>
        <Route element={<KnowledgeBasePageLayout />}>
          <Route path={'/'} element={<KnowledgeBaseViewPage />} />
          <Route
            path={`${KnowledgeBaseRoutes.createDocument}/*`}
            element={<KnowledgeBaseDocumentView />}
          />
          <Route
            path={`${KnowledgeBaseRoutes.editDocument}/:id`}
            element={<KnowledgeBaseDocumentView />}
          />
        </Route>
      </Route>
    </RoutesWithNotFound>
  )
})
